<template>
    <nav>
        <div class="row">
            <div class="col-sm-3">
                <label>Station Group</label>
                <select class="form-select form-select-sm" v-model="selectedStationGroupId">
                    <option :value="null">All Groups</option>
                    <option v-for="stationGroup in StationGroup" :value="stationGroup.id" :key="stationGroup.id">{{
                        stationGroup.name }}</option>
                </select>
            </div>
            <div class="col-sm-3 ps-0">
                <label>Station</label>
                <select class="form-select form-select-sm" v-model="selectedStationId" @change="stationChanged">
                    <option :value="null">All Stations</option>
                    <option v-for="station in filteredStations" :value="station.id" :key="station.id">{{ station.name }}
                    </option>
                </select>
            </div>
            <div class="col-sm-3 ps-0">
                <label>Product Group</label>
                <select class="form-select form-select-sm" v-model="selectedProductGroupId">
                    <option :value="null">All Product Groups</option>
                    <option v-for="productGroup in productGroups" :value="productGroup.id" :key="productGroup.id">{{
                        productGroup.name }}</option>
                </select>
            </div>
            <div class="col-sm-3 ps-0">
                <label>Product (with station)</label>
                <select class="form-select form-select-sm" v-model="selectedStationProductId">
                    <option :value="null">All Products</option>
                    <option v-for="sp in filteredStationProducts" :value="sp.id" :key="sp.id">{{ sp.name }}</option>
                </select>
            </div>
        </div>
    </nav>
</template>

<script>
import StationService from '../../../services/StationsService';
import ProductService from '../../../services/Products';
import StationProductService from '../../../services/StationProductService';

export default {
    name: "ReportFiltersForProductWiseReport",
    data: () => ({
        StationGroup: [],
        allStations: [],
        productGroups: [],
        allStationProducts: []
    }),
    computed: {

        // F-03: station/product groups are now backed by Vuex so the report
        // request carries them. Selecting a station group resets station + product
        // to "All"; selecting a product group resets the product to "All".
        selectedStationGroupId: {
            get() {
                return this.$store.state.reportPageFilters.selectedStationGroupId;
            },
            set(stationGroupId) {
                this.$store.dispatch('selectedStationGroupId', stationGroupId);
                this.$store.dispatch('selectedStationId', null);
                this.$store.dispatch('selectedStationProductId', null);
            }
        },
        selectedProductGroupId: {
            get() {
                return this.$store.state.reportPageFilters.selectedProductGroupId;
            },
            set(productGroupId) {
                this.$store.dispatch('selectedProductGroupId', productGroupId);
                this.$store.dispatch('selectedStationProductId', null);
            }
        },

        selectedStationId: {
            get() {
                let selectedStationProductIdCheck = this.$store.state.reportPageFilters.selectedStationId;
                return selectedStationProductIdCheck === null ? null : selectedStationProductIdCheck;
            },
            set(stationId) {
                this.$store.dispatch('selectedStationId', stationId);
            }
        },
        selectedStationProductId: {
            get() {
                let selectedStationProductIdCheck = this.$store.state.reportPageFilters.selectedStationProductId;
                return selectedStationProductIdCheck === null ? null : selectedStationProductIdCheck;
            },
            set(stationProductId) {
                this.$store.dispatch('selectedStationProductId', stationProductId);
            }
        },

        filteredStations() {
            let vm = this;
            if (this.selectedStationGroupId == null || this.selectedStationGroupId == 0) {
                return vm.allStations;
            }
            return vm.allStations.filter(function (station) {
                return station.station_group.id === vm.selectedStationGroupId;
            });
        },

        filteredProductGroups() {
            let vm = this;
            let productGroups = this.productGroups;

            if (this.selectedStationGroupId != null && this.selectedStationGroupId != 0) {
                productGroups = productGroups.filter(function (pg) {
                    return pg.station_group_id === vm.selectedStationGroupId;
                });
            }

            if (this.selectedStationId != null && this.selectedStationId != 0) {
                productGroups = productGroups.filter(function (pg) {
                    return pg.station_id === vm.selectedStationId;
                });
            }

            return productGroups;
        },

        filteredStationProducts() {
            let stationProducts = this.allStationProducts.map(function (sp) {
                sp.name = `${sp.product_name} (Station: ${sp.station_name} )`;
                return sp;
            });

            let vm = this;

            if (this.selectedStationGroupId != null && this.selectedStationGroupId != 0) {
                stationProducts = stationProducts.filter(function (sp) {
                    return sp.station_group_id === vm.selectedStationGroupId;
                });
            }

            if (this.selectedStationId != null && this.selectedStationId != 0) {
                stationProducts = stationProducts.filter(function (sp) {
                    return sp.station_id === vm.selectedStationId;
                });
            }

            if (this.selectedProductGroupId != null && this.selectedProductGroupId != 0) {
                stationProducts = stationProducts.filter(function (sp) {
                    return sp.product_group_id === vm.selectedProductGroupId;
                });
            }

            return stationProducts;
        },
        selectedStation() {
            const vm = this;
            return vm.allStations.find(station => station.id === vm.selectedStationId);
        },
        selectedStationProduct() {
            const vm = this;
            return vm.allStationProducts.find(sp => sp.id === vm.selectedStationProductId);
        }
    },
    // F-03: auto-select-first watchers removed; filters default to "All" so a
    // station/product group can be viewed in aggregate without forcing a machine.
    methods: {
        stationChanged() {
            // Reflect the chosen station's group without wiping the station
            // selection (dispatch directly rather than via the resetting setter).
            if (this.selectedStation && this.selectedStation.station_group) {
                this.$store.dispatch('selectedStationGroupId', this.selectedStation.station_group.id);
            }
        },
        stationProductSelected() {
            if (this.selectedStationProduct) {
                this.$store.dispatch('selectedProductGroupId', this.selectedStationProduct.product_group_id);
                this.$store.dispatch('selectedStationId', this.selectedStationProduct.station_id);
                this.$store.dispatch('selectedStationGroupId', this.selectedStationProduct.station_group_id);
            }
            this.$emit('stationProductSelected', {
                'stationProductId': this.selectedStationProductId,
                'stationProduct': this.selectedStationProduct
            });
        },
    },
    mounted() {
        StationService.fetchAllGroups(response => {
            this.StationGroup = response;
        });
        StationService.fetchAll([], response => {
            this.allStations = response;
        });
        ProductService.fetchAllGroups(response => {
            this.productGroups = response;
        });
        StationProductService.allStationProductsForReportDropdown(response => {
            this.allStationProducts = response;
        });

    }
}
</script>
